import { createIndexedDbAdapter } from './indexed-db-adapter.js'

export function createImageRepository({ adapter = createIndexedDbAdapter() } = {}) {
  const memory = new Map()
  return {
    async put(image) { if (adapter.available()) await adapter.putImage(image); memory.set(image.imageId, image); return image.imageId },
    async get(imageId) { if (memory.has(imageId)) return memory.get(imageId); if (adapter.available()) return adapter.getImage(imageId); return null },
    async remove(imageId) { memory.delete(imageId); if (adapter.available()) await adapter.deleteImage(imageId) },
    async list() { return [...memory.values()] },
  }
}
